import React from 'react';

export const EqLocNameModal = {
  title: 'Earthquake Location',
  body: (
    <div>
      <p>
        The Country, State, Province or City where the Earthquake occurred (For
        example enter USA or California or San Francisco)
      </p>
      <p>
        This is only an approximate geographic location. Events prior to 1900 were
        not instrumentally located, therefore, the location given is based on the
        latitude and longitude of the city where the damage occurred. In the
        Geographic Location column, the country is listed first, then the province
        or state, and finally the city or cities where damage was reported. If there
        are different spellings of a city name the additional spellings are in
        parentheses.
      </p>
    </div>
  ),
};
